/**
 * StandOut WordPress Theme
 * Template-specific functionality initialization
 * Uses body classes to determine current template
 *
 * @package StandOut
 * @since 2.0.0
 */
// Default page template
const page = document.getElementsByClassName("page-template-default");
if (page.length > 0) {
    import("./page");
}
// Homepage hero animation
const homepageHero = document.querySelector(".homepage-hero");
if (homepageHero) {
    import("./headers/homepage-hero");
}
// Text hero header
const textHero = document.querySelector(".text-hero");
if (textHero) {
    import("./headers/text-hero");
}
// Featured header
const featuredHeader = document.querySelector(".featured-header");
if (featuredHeader) {
    import("./headers/featured-header");
}
// Blog archive header
const blogArchiveHeader = document.querySelector(".blog-archive__header");
if (blogArchiveHeader) {
    import("./blog-archive");
}
// Clone-capable blocks: maps CSS class to module path
// Add new blocks here to enable them as content-scroll-slider targets
const CLONE_CAPABLE_BLOCKS = {
    "text-with-3-steps": () => import("./blocks/text-with-3-steps"),
    "image-with-text": () => import("./blocks/image-with-text"),
    "featured-case": () => import("./blocks/featured-case"),
};
// Query DOM elements
const contentScrollSliders = document.querySelectorAll(".content-scroll-slider");
const svgReveal = document.querySelector(".svg-reveal");
const aboutLoeks = document.querySelector(".about-loeks");
const teamSlider = document.querySelector(".team-slider");
const twoImages = document.querySelector(".two-images");
const videoBlock = document.querySelector(".video-block");
const contactForm = document.querySelector(".contact-form");
const quoteContent = document.querySelector(".quote-content");
// Initialize all scroll animations in sequence, then refresh ScrollTrigger
const initScrollAnimations = async () => {
    // Step 1: Auto-detect and import ALL blocks that follow ANY content-scroll-slider
    // This ensures their animators are registered before content-scroll-slider uses the registry
    const importedCloneTargets = new Set();
    for (const slider of contentScrollSliders) {
        const nextSection = slider.nextElementSibling;
        if (nextSection) {
            for (const [className, importFn] of Object.entries(CLONE_CAPABLE_BLOCKS)) {
                if (nextSection.classList.contains(className) &&
                    !importedCloneTargets.has(className)) {
                    await importFn();
                    importedCloneTargets.add(className);
                    break;
                }
            }
        }
    }
    // Step 2: Content scroll slider (clones next section, uses registry)
    if (contentScrollSliders.length > 0) {
        await import("./blocks/content-scroll-slider");
    }
    // Step 3: Import remaining clone-capable blocks for standalone mode
    // (skip the ones already imported as clone targets)
    for (const [className, importFn] of Object.entries(CLONE_CAPABLE_BLOCKS)) {
        const element = document.querySelector(`.${className}`);
        if (element && !importedCloneTargets.has(className)) {
            await importFn();
        }
    }
    // Step 4: Other pinned sections in DOM order
    if (svgReveal) {
        await import("./blocks/svg-reveal");
    }
    if (aboutLoeks) {
        await import("./blocks/about-loeks");
    }
    // Step 5: Non-pinned sections
    if (teamSlider) {
        await import("./blocks/team-slider");
    }
    if (twoImages) {
        await import("./blocks/two-images");
    }
    if (videoBlock) {
        await import("./blocks/video-block");
    }
    if (contactForm) {
        await import("./blocks/contact-form");
    }
    if (quoteContent) {
        await import("./blocks/quote-content");
    }
    const threeColumns = document.querySelector(".three-columns");
    if (threeColumns) {
        await import("./blocks/three-columns");
    }
    // Refresh ScrollTrigger after all pinned sections are initialized
    if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
    }
};
initScrollAnimations();
// Client logos slider (Swiper-based, not GSAP)
const clientLogos = document.querySelector(".client-logos");
if (clientLogos) {
    import("./blocks/client-logos");
}
// Scroll progress timeline
const scrollProgress = document.querySelector(".scroll-progress-container");
if (scrollProgress) {
    import("./footer");
}
// Single post
const singlePost = document.querySelector(".single-post");
if (singlePost) {
    import("./single-post");
}
export {};
